import type { SxProps, Theme } from '@mui/material/styles';

import { signupDisabledButtonStyles, signupPageStyles, signupTypography } from '../../../pages/signup/SignupPage/SignupPage.styles';

const applicationButtonBlue = '#0090fa';
const applicationButtonBlueHover = '#007dcc';

export const signupAccountMethodsStyles = {
  productSection: signupPageStyles.productSection,
  accountHeading: signupPageStyles.accountHeading,
  sectionDescription: signupPageStyles.sectionDescription,
  actionError: signupPageStyles.actionError,
  input: signupPageStyles.input,
  emailButton: signupPageStyles.emailButton,
  accentLink: signupPageStyles.accentLink,
  providerStack: (): SxProps<Theme> => ({
    display: 'grid',
    gap: 1.5,
  }),
  providerButton: (theme: Theme): SxProps<Theme> => ({
    height: '49px',
    minHeight: '49px',
    justifyContent: 'flex-start',
    p: 0,
    overflow: 'hidden',
    border: `1px solid ${applicationButtonBlue}`,
    borderRadius: 0,
    bgcolor: applicationButtonBlue,
    color: theme.palette.common.white,
    boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075)',
    textTransform: 'none',
    '&:hover': {
      borderColor: applicationButtonBlueHover,
      bgcolor: applicationButtonBlueHover,
    },
    '&:focus-visible': {
      outline: '3px solid rgba(0, 144, 250, 0.35)',
      outlineOffset: '3px',
    },
    '&.Mui-disabled': {
      ...signupDisabledButtonStyles,
    },
  }),
  providerIconFrame: (): SxProps<Theme> => ({
    display: 'flex',
    width: '50px',
    height: '49px',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    bgcolor: '#fff',
  }),
  providerIcon: (): SxProps<Theme> => ({
    width: '36px',
    height: '36px',
    objectFit: 'contain',
  }),
  providerLabel: (): SxProps<Theme> => ({
    display: 'flex',
    minWidth: 0,
    flex: 1,
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center',
    px: 1.5,
    fontSize: signupTypography.standard,
    fontWeight: 700,
    lineHeight: 1.4,
    textAlign: 'center',
  }),
  emailDivider: (theme: Theme): SxProps<Theme> => ({
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    gap: 2,
    my: 2,
    color: theme.palette.grey[700],
    fontSize: signupTypography.supporting,
    '&::before, &::after': {
      content: '""',
      height: '1px',
      bgcolor: theme.palette.divider,
    },
  }),
  emailSignupRow: (): SxProps<Theme> => ({
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: 'minmax(0, 1fr) auto' },
    gap: 1.5,
    alignItems: 'stretch',
  }),
  consentArea: (): SxProps<Theme> => ({
    mt: 2.75,
  }),
  consentLabel: (): SxProps<Theme> => ({
    alignItems: 'center',
    m: 0,
    '& .MuiCheckbox-root': {
      ml: '-9px',
    },
    '& .MuiFormControlLabel-label': {
      fontSize: signupTypography.supporting,
      lineHeight: 1.5,
    },
  }),
};
